import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavController, NavParams, PopoverController, LoadingController } from 'ionic-angular';
import * as moment from 'moment';

import { AuthProvider } from '../../providers/auth/auth';
import { JobsProvider } from '../../providers/jobs/jobs';

import { JobInfoComponent } from './../../shared/jobs/job-info'

import { IJob } from '../../interfaces/jobs';

@Component({
  selector: 'page-accounts',
  templateUrl: 'accounts.html',
})
export class AccountsPage implements OnInit {
  title = 'Accounts';
  fbUser: any;
  currentUser: any;
  currentUserSubscription: any;
  userDataLoaded = false;

  openJobs: Array<IJob> = [];
  openJobsSubscription: any;
  openJobsDataLoaded = false;

  upcommingJobs: Array<IJob> = [];
  upcommingJobsSubscription: any;
  upcommingJobsDataLoaded = false;

  completedJobs: Array<IJob> = [];
  completedJobsSubscription: any;
  completedJobsDataLoaded = false;

  loader;

  constructor(public navCtrl: NavController,
    public popoverCtrl: PopoverController,
    public loadingCtrl: LoadingController,
    private authProvider: AuthProvider,
    private jobsProvider: JobsProvider) {
  }

  ngOnInit() {
    this.loader = this.loadingCtrl.create({
      content: 'Loading jobs...'
    });
    this.loader.present();

    this.authProvider.getFbUser().then(fbUser => {
      console.log(fbUser);
      this.currentUserSubscription = this.authProvider
        .getUserByUid(fbUser.uid)
        .subscribe(
          data => {
            console.log(data);
            this.currentUser = data;

            this.loadRecruiterJobs();

            this.userDataLoaded = true;
            return data;
          },
          err => {
            console.log(err);
          }
        );
    }); 
  }

  ngOnDestroy() {
    if (this.currentUserSubscription) {
      this.currentUserSubscription.unsubscribe();
    }
    if (this.openJobsSubscription) {
      this.openJobsSubscription.unsubscribe();
    }
  }

  loadRecruiterJobs() {
    this.upcommingJobsSubscription = this.jobsProvider.getRecruiterJobs(this.currentUser.uid).subscribe(
      result => {
        console.log(result);
        const now = moment().format();
        // console.log(now);
        this.upcommingJobs = [];
        this.completedJobs = [];
        result.forEach(job => {
          if (moment(job.start).format() > now) {
            console.log('job starts in the future');
            this.upcommingJobs.push(job);
          } else {
            if (job.paymentStatus > 0) {
              this.completedJobs.push(job);
            }
          }
        });
        setTimeout(() => {
          this.loader.dismiss();
        }, 100);
        this.upcommingJobsDataLoaded = true;
        return result;
      },
      err => {
        console.log(err);
      }
    )
  }

  openJob(job: IJob) {
    console.log(job);
    let popover = this.popoverCtrl.create(JobInfoComponent, { job: job, user: this.currentUser }, { showBackdrop: true, enableBackdropDismiss: false, cssClass: 'job-popover' });
    popover.present({
      ev: job
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AccountsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/accounts/accounts.ts